module.exports = __webpack_public_path__ + "media/Enter-Some-Words.a2a6e82c.mp4";